<template>
    <div>
        <div class="border-b border-blue-900 px-3 py-2">
            <h2 class="font-bold leading-none">Montgomery County Performance Standard</h2>
        </div>
        <p class="my-3 px-3">
            The targets displayed below are preliminary based on the EUI standards <a href="https://www.montgomerycountymd.gov/DEP/Resources/Files/energy/commercial/BEPS%20Exec%20Reg_Cln%201_8.pdf" target="_blank" class="text-blue-900 font-bold underline">proposed in regulations</a> and will not be final until the regulations are approved by County Council.
            Compliance with interim and final standards is projected based on latest benchmarking data. Actual compliance will be based on building performance during the interim and final period.
        </p>
        <div class="px-3">
            <div class="mt-5">
                <div class="max-w-2xl">
                    <base-table
                        class="report-table"
                        :data="performanceList"
                        :columns="columns"
                        :loading="loading"
                    >
                        <template v-slot="{ row, index }">
                            <td :class="`${ tableRowBaseClass(index) }`">{{ row.standard }}</td>
                            <td :class="`${ tableRowBaseClass(index) }`">{{ row.calendar_year }}</td>
                            <td :class="`${ tableRowBaseClass(index) } text-right`">{{ row.eui }}</td>
                            <td :class="`${ tableRowBaseClass(index) } text-right`">{{ row.meeting }}</td>
                        </template>
                    </base-table>
                </div>
            </div>
        </div>
    </div>
</template>
<script>

export default {
    props: {
        submissions: {
            type: Array,
            default: () => []
        },
        beps: {
            type: Object,
            default: () => {}
        },
        bepsYearlyData: {
            type: Object,
            default: () => {}
        },
        isReportingStartYearCurrentYear: {
            type: Boolean,
            default: false
        }
    },

    data() {
        return {
            columns: [
                { label: 'Standard', field: 'standard', customHeaderClass: 'align-top border border-b-4 border-white' },
                { label: 'Reporting Year', field: 'calendar_year', customHeaderClass: 'align-top border border-b-4 border-white' },
                { label: 'NN Site EUI', field: 'eui', customHeaderClass: 'align-top border border-b-4 border-white' },
                { label: 'Meeting EUI Standard?', field: 'meeting', customHeaderClass: 'align-top border border-b-4 border-white' }
            ],
            loading: false,
        };
    },

    computed: {

        performanceList() {
            const list = [];
            const bepsRecord = this.beps;
            const bepsYearlyData = this.bepsYearlyData;
            if (bepsRecord) {
                list.push({
                    standard: 'Baseline',
                    calendar_year: bepsRecord?.baseline_period || 'N/A',
                    eui: this.isReportingStartYearCurrentYear ? 'TBD' : (bepsRecord?.baseline_performance_display || 'N/A'),
                    meeting: ''
                });

                if (bepsYearlyData && bepsYearlyData.records.length) {
                    list.push({
                        standard: 'Latest Performance',
                        calendar_year: bepsYearlyData.records[0].data.reporting_year,
                        eui: this.isReportingStartYearCurrentYear ? 'Undisclosed' : bepsYearlyData.records[0].data.normalized_net_site_eui,
                        meeting: ''
                    });
                }

                list.push({
                    standard: 'Interim Standard',
                    calendar_year: bepsRecord.interim_standard_deadline || 'N/A',
                    eui: this.isReportingStartYearCurrentYear ? 'TBD' : (bepsRecord?.interim_performance_standard_display || 'N/A'),
                    meeting: this.isReportingStartYearCurrentYear ? 'TBD' : bepsRecord?.meeting_interim_standard
                });

                list.push({
                    standard: 'Final Standard',
                    calendar_year: bepsRecord.final_standard_deadline || 'N/A',
                    eui: bepsRecord?.final_performance_standard_display || 'N/A',
                    meeting: this.isReportingStartYearCurrentYear ? 'TBD' : bepsRecord?.meeting_final_standard
                });
            }

            return list;
        }

    },

    methods: {
        tableRowBaseClass(index) {
            return index % 2 ? 'bg-blue-50' : 'bg-blue-100';
        },
    }
};

</script>
